import type { ReactNode } from 'react'
import { createContext, useEffect, useState } from 'react'

import type { Settings } from '@/types/settings'
import { applyDefaultSettings } from '@/lib/settings/apply-default-settings'

export interface SettingsContextValue {
	settings: Settings
	setSettings: (settings: Settings) => void
}

export const SettingsContext = createContext<SettingsContextValue>({
	settings: applyDefaultSettings({}),
	setSettings: () => {
		// noop
	},
})

export interface SettingsProviderProps {
	children: ReactNode
	settings: Settings
}

export function SettingsProvider({ children, settings: initialSettings }: SettingsProviderProps) {
	const [state, setState] = useState<Settings>(initialSettings)

	useEffect(() => {
		setState(initialSettings)
	}, [initialSettings])

	return (
		<SettingsContext.Provider
			value={{
				settings: state,
				setSettings: (newSettings: Settings) => {
					setState(newSettings)
				},
			}}
		>
			{children}
		</SettingsContext.Provider>
	)
}

export const SettingsConsumer = SettingsContext.Consumer
